// this file is automatically generated by git-version.mjs script
export const versions = {
  version: '0.0.0',
  revision: '8649f28',
  commitHash: '8649f2841950c4a6de1f8b24043b2d0f8505d2e0',
  branch: 'HEAD',
  date: '2026-02-09T21:46:10.724Z',
};
